import { IPseudoGroup, ISelectFieldOption } from "@/app/fields/types";

export const DEFAULT_GROUP_LABEL = "-";

export const splitOptionLevels = (
  options: ISelectFieldOption[]
): IPseudoGroup[] => {
  const grouped = options.reduce((prev, next) => {
    const groupKey = next.group || DEFAULT_GROUP_LABEL;
    if (!prev[groupKey]) {
      prev[groupKey] = [];
    }
    prev[groupKey].push(next);
    return prev;
  }, {} as { [key: string]: ISelectFieldOption[] });

  return Object.entries(grouped).map(([key, _options]) => ({
    label: key,
    value: key,
    _options: _options.map((option) => ({ ...option, group: key })),
  }));
};
